<template src="./job.html"></template>

<script>
import JobService from 'Services/JobService';
import Pagination from 'Components/pagination/Pagination.vue';

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      jobsJP: [],
      jobsVN: [],
      internsJP: [],
      internsVN: [],
      i18n: 2,

      // pagination job jp
      currentPageJobJP: 1,
      fromJobJP: 0,
      toJobJP: 0,
      totalJobJP: 0,
      perPageJobJP: 12,
      lastPageJobJP: 1,

      // pagination job vn
      currentPageJobVN: 1,
      fromJobVN: 0,
      toJobVN: 0,
      totalJobVN: 0,
      perPageJobVN: 12,
      lastPageJobVN: 1,

      // pagination intern jp
      currentPageInternJP: 1,
      fromInternJP: 0,
      toInternJP: 0,
      totalInternJP: 0,
      perPageInternJP: 12,
      lastPageInternJP: 1,

      // pagination intern vn
      currentPageInternVN: 1,
      fromInternVN: 0,
      toInternVN: 0,
      totalInternVN: 0,
      perPageInternVN: 12,
      lastPageInternVN: 1,

      isLoading: true,
    };
  },

  created() {
    this.listJobClientJP();
    this.listJobClientVN();
    this.listInternClientJP();
    this.listInternClientVN();
  },

  methods: {
    listJobClientJP() {
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }
      this.isLoading = true;
      const params = {
        page: this.currentPageJobJP,
        limit: this.perPageJobJP,
        i18n: this.i18n,
        type: 1,
        address: 1,
      };
      JobService.listClientType(params)
        .then((response) => {
          this.jobsJP = response.data.data;
          this.fromJobJP = response.data.from;
          this.toJobJP = response.data.to;
          this.totalJobJP = response.data.total;
          this.lastPageJobJP = response.data.last_page;
        })
        .catch(() => {});
    },

    onPageChangeJobJP(pageJobJP) {
      this.currentPageJobJP = pageJobJP;
      this.listJobClientJP();
    },

    listJobClientVN() {
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }
      this.isLoading = true;
      const params = {
        page: this.currentPageJobVN,
        limit: this.perPageJobVN,
        i18n: this.i18n,
        type: 1,
        address: 2,
      };
      JobService.listClientType(params)
        .then((response) => {
          this.jobsVN = response.data.data;
          this.fromJobVN = response.data.from;
          this.toJobVN = response.data.to;
          this.totalJobVN = response.data.total;
          this.lastPageJobVN = response.data.last_page;
        })
        .catch(() => {});
    },

    onPageChangeJobVN(pageJobVN) {
      this.currentPageJobVN = pageJobVN;
      this.listJobClientVN();
    },


    listInternClientJP() {
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }
      this.isLoading = true;
      const params = {
        page: this.currentPageInternJP,
        limit: this.perPageInternJP,
        i18n: this.i18n,
        type: 2,
        address: 1,
      };
      JobService.listClientType(params)
        .then((response) => {
          this.internsJP = response.data.data;
          this.fromInternJP = response.data.from;
          this.toInternJP = response.data.to;
          this.totalInternJP = response.data.total;
          this.lastPageInternJP = response.data.last_page;
        })
        .catch(() => {});
    },

    onPageChangeInternJP(pageInternJP) {
      this.currentPageInternJP = pageInternJP;
      this.listInternClientJP();
    },

    listInternClientVN() {
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }
      this.isLoading = true;
      const params = {
        page: this.currentPageInternVN,
        limit: this.perPageInternVN,
        i18n: this.i18n,
        type: 2,
        address: 2,
      };
      JobService.listClientType(params)
        .then((response) => {
          this.internsVN = response.data.data;
          this.fromInternVN = response.data.from;
          this.toInternVN = response.data.to;
          this.totalInternVN = response.data.total;
          this.lastPageInternVN = response.data.last_page;
        })
        .catch(() => {});
    },

    onPageChangeInternVN(pageInternVN) {
      this.currentPageInternVN = pageInternVN;
      this.listInternClientVN();
    },
  },
};
</script>
<style scoped>
.btn {
  font-size: 14px;
  color: #fff;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: linear-gradient(50deg, #9e396ffa 0%, #3f2e2f52 100%);
  border-radius: 50px;
  border: none;
};
.btn:hover {
  color: rgba(62,46,46,1);
  background: linear-gradient(50deg, #9e396ffa 0%, #3f2e2f52 100%);
};
.btn:active {
  color: rgba(62,46,46,1);
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: linear-gradient(50deg, #9e396ffa 0%, #3f2e2f52 100%);
  border-radius: 50px;
  border: none;
}
</style>
